<template lang="html">

  <section>

    <div class="politicas">

      <section class="middle-intro row-start">

        <div class="container">
          <h1 class="title -intro">Política de privacidad</h1>
        </div>

      </section>

      <div class="container">
        <p>En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016,
          relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales, por el
          que se deroga la directiva 95/46/CE (en adelante, RGPD), de la Ley 34/2002, de 11 de julio, de servicios de la
          sociedad de la información y de comercio electrónico (en adelante, LSSI-CE) y de la Ley rgánica 3/2018, de
          Protección de Datos Personales y garantía de los derechos digitales, INNOPULSE ASESORES TECNOLOGICOS SL
          garantiza la protección y confidencialidad de los datos personales, de cualquier tipo que nos proporcionen
          nuestros clientes, de acuerdo con lo dispuesto en el Reglamento General de Protección de Datos de Carácter
          Personal.</p>
        <p>La Política de Protección de Datos de INNOPULSE ASESORES TECNOLOGICOS SL descansa en el principio de
          responsabilidad proactiva, según el cual el Responsable del tratamiento es responsable del cumplimiento del
          marco normativo y jurisprudencial, siendo capaz de demostrarlo ante las autoridades de control
          correspondientes.</p>
        <p>Los datos facilitados serán tratados en los términos establecidos en el RGPD; en este sentido,
          <strong>INNOPULSE ASESORES TECNOLOGICOS SL</strong> ha adoptado los niveles de protección que legalmente se
          exigen, y ha instalado todas las medidas técnicas a su alcance para evitar la pérdida, mal uso, alteración,
          acceso no autorizado por terceros, expuestos a continuación. No obstante, el usuario debe ser consciente de
          que las medidas de seguridad en Internet no son inexpugnables.
        </p>
        <h2 class="title">RESPONSABLE DEL TRATAMIENTO: ¿QUIÉNES SOMOS?</h2>
        <ul class="listado-privacidad">
          <li>Denominación: INNOPULSE ASESORES TECNOLOGICOS SL (en adelante, INNOPULSE) CIF: B84465863</li>
          <li>Dirección: Calle Aguacate 41, Edificio B4, 2º Local 6, 28054 Madrid Teléfono: 911427887</li>
          <li>Correo electrónico: lopd@innopulse.es </li>
        </ul>

        <h2 class="title">FINALIDAD DEL TRATAMIENTO: ¿PARA QUÉ USAREMOS SUS DATOS?</h2>

        <p>Todos los datos facilitados por nuestros clientes y/o visitantes en la web de INNOPULSE o a su personal,
          serán incluidos en ficheros, automatizados o no, creados y mantenidos bajo la responsabilidad del mismo,
          imprescindibles para prestar los servicios solicitados por los usuarios, o para resolver las dudas o
          cuestiones planteadas por nuestros visitantes.</p>


        <h2 class="title">LEGITIMIDAD DEL TRATAMIENTO: ¿POR QUÉ NECESITAMOS SUS DATOS?</h2>

        <ul>
          <li class="listado-privacidad-letra">Relación contractual: Es la que aplica cuando contrata alguno de nuestros
            servicios.</li>
          <li class="listado-privacidad-letra">Interés legítimo: Para atender a las consultas y reclamaciones que nos
            plantee y para gestionar el cobro de las cantidades adeudadas.</li>
          <li class="listado-privacidad-letra">Su consentimiento: Si es usuario de nuestra web, mediante la marcación de
            la casilla que figura en el formulario de contacto, nos autoriza a que le remitamos las comunicaciones
            necesarias para dar respuesta a la consulta o solicitud de información planteada.</li>
        </ul>


        <h2 class="title">DESTINATARIOS: ¿CON QUIÉN COMPARTIMOS SUS DATOS?</h2>
        <p>No cedemos sus datos personales a nadie, a excepción de aquellas entidades públicas o privadas a las cuales
          estemos obligados a facilitar sus datos personales con motivo del cumplimiento de alguna ley. Por poner un
          ejemplo, la Ley Tributaria obliga a facilitar a la Agencia Tributaria determinada información sobre
          operaciones económicas que superen una determinada cantidad.
        </p>
        <p>En el caso de que, al margen de los supuestos comentados, necesitemos dar a conocer su información personal a
          otras entidades, le solicitaremos previamente su permiso a través de opciones claras que le permitirán decidir
          a este respecto.</p>

        <h2 class="title">COMUNICACIÓN: ¿DÓNDE PODRÍAMOS ENVIAR TUS DATOS?</h2>
        <p>No realizaremos transferencias internacionales de sus datos personales para ninguna de las finalidades
          indicadas.</p>

        <h2 class="title">CONSERVACIÓN: ¿CUÁNTO TIEMPO MANTENDREMOS TUS DATOS?</h2>
        <p>Solo conservaremos sus datos personales durante el tiempo que resulte necesario para lograr los fines para
          los que fueron recabados. A la hora de determinar el oportuno periodo de conservación, examinamos los riesgos
          que conlleva el tratamiento, así como nuestras obligaciones contractuales, legales y normativas, las políticas
          internas de conservación de datos y nuestros intereses de negocio legítimos descritos en el presente Aviso de
          Privacidad y Política de Cookies.</p>
        <p>En este sentido, INNOPULSE conservará los datos personales una vez terminada su relación con Ud., debidamente
          bloqueados, durante el plazo de prescripción de las acciones que pudieran derivarse de la relación mantenida
          con el interesado.
        </p>
        <p>Una vez bloqueados, sus datos resultarán inaccesibles para INNOPULSE, y no serán tratados excepto para su
          puesta a disposición a las Administraciones públicas, Jueces y Tribunales, para la atención de las posibles
          responsabilidades nacidas de los tratamientos, así como para el ejercicio y defensa de reclamaciones ante la
          Agencia Española de Protección de Datos.</p>
        <h2 class="title">SEGURIDAD: ¿CÓMO VAMOS A PROTEGER SUS DATOS?</h2>
        <p>Empleamos todos los esfuerzos razonables para mantener la confidencialidad de la información personal que se
          trate en nuestros sistemas. Mantenemos estrictos niveles de seguridad para proteger los datos de carácter
          personal que procesamos frente a pérdidas fortuitas y a accesos, tratamientos o revelaciones no autorizados,
          habida cuenta del estado de la tecnología, la naturaleza y los riesgos a que están expuestos los datos. No
          obstante, no podemos responsabilizarnos del uso que Ud. haga de los datos (incluido usuario y contraseña) que
          utilice en nuestra web. Nuestro personal sigue estrictas normas de privacidad y en el caso de que contratemos
          a terceros para prestar servicios de soporte, les exigimos que acaten las mismas normas y nos permitan
          auditarles para verificar su cumplimiento.</p>
        <h2 class="title">SUS DERECHOS: ¿QUÉ DERECHOS PUEDE EJERCER COMO INTERESADO?</h2>
        <p>Le informamos que podrá ejercer los siguientes derechos:</p>

        <ul>
          <li class="listado-privacidad-letra">Derecho de acceso a sus datos personales, para saber cuáles están siendo
            objeto de tratamiento y las operaciones de tratamiento llevadas a cabo con ellos</li>
          <li class="listado-privacidad-letra">Derecho de rectificación de cualquier dato personal inexacto</li>
          <li class="listado-privacidad-letra">Derecho de supresión de sus datos personales, cuando esto sea posible
            (por ejemplo, por imperativo legal)</li>
          <li class="listado-privacidad-letra">Derecho de limitación del tratamiento de sus datos personales cuando la
            exactitud, la legalidad o la necesidad del tratamiento de los datos resulte dudosa, en cuyo caso, podremos
            conservarlos para el ejercicio o la defensa de reclamaciones.</li>
          <li class="listado-privacidad-letra">Derecho de oposición al tratamiento de sus datos personales, cuando la
            base legal que nos habilite para su tratamiento de las indicadas sea nuestro interés legítimo. INNOPULSE
            dejará de tratar tus datos salvo que tenga un interés legítimo o sea necesario para la defensa de
            reclamaciones, cuando proceda este derecho.
          </li>

          <li class="listado-privacidad-letra">Derecho a la portabilidad de sus datos, cuando la base legal que nos
            habilite para su tratamiento sea la existencia de una relación contractual o su consentimiento.</li>

          <li class="listado-privacidad-letra"> Derecho a revocar el consentimiento otorgado a INNOPULSE.</li>

        </ul>
        <p>Para ejercitar sus derechos, puede hacerlo de manera gratuita y en cualquier momento, contactando con
          nosotros en la dirección Calle Aguacate 41, Edificio B4, 2º Local 6, 28054 Madrid, o escribiendo un correo a
          contacto@innopulse.es, adjuntando siempre copia del DNI.</p>






          <h2 class="title">TUTELA DE DERECHOS: ¿DÓNDE PUEDE FORMULAR UNA RECLAMACIÓN?</h2>
          <p>En caso de que entienda que sus derechos han sido desatendidos por nuestra entidad, puede formular una reclamación en la Agencia Española de Protección de Datos, a través de alguno de los medios siguientes:</p>
          <ul class="listado-privacidad">
            <li>Sede electrónica: https://www.aepd.es</li>
            <li>Correo postal: Agencia Española de Protección de Datos, C/ Jorge Juan, 6, 28001, Madrid</li>
            <li>Teléfono: 901.100.099 y 912.663.517</li>

          </ul>
          <p>Formular una reclamación en la Agencia Española de Protección de Datos no conlleva ningún coste y no es necesaria la asistencia de abogado ni procurador.</p>


          <h2 class="title">ACTUALIZACIONES: ¿QUÉ CAMBIOS PUEDE HABER EN ESTA POLÍTICA DE PRIVACIDAD?</h2>


<p>INNOPULSE se reserva el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales que puedan afectar el cumplimiento de la misma.</p>








      </div>

    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'politica-de-privacidad',
  props: [],
  mounted() {

  },
  data() {
    return {

    }
  },
  methods: {

  },
  computed: {

  }
}
</script>

<style scoped >
.politica-de-privacidad {}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue